import React, { useContext, useEffect } from "react";
import ReviewsPage from "../pages/ReviewsPage";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import { RemoveActionProvider } from "../actions/remove/RemoveActionContext";
import { ListActionProvider } from "../actions/list/ListActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";

export default function ReviewRouterWrapper(props: {
  config?: {showReviewSchemaSelector?: boolean};
  filters?: any;
  key?: string;
  formDefaultValues?: any;
  formFilterValues?: any;
}) {
  const {
    config,
    filters,
    key,    
    formDefaultValues,
    formFilterValues,
  } = props;

  const { commerceId } = useContext(TenantAndCommerceContext);

  return (
    <ListActionProvider key={key}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <EditActionProvider>
            <ReviewsPage
              config={config}
              filters={filters}
              formDefaultValues={{
                ...formDefaultValues,
                reviewable_id: commerceId,
                reviewable_type: "App\\Models\\Commerce",
              }}
              formFilterValues={formFilterValues}
            />
          </EditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}
